module.exports = __webpack_public_path__ + "img/2.7.b89ff514.png";